export default "__VITE_ASSET__DIIxRFj___"